import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles(() => ({
    filterIcon: {
        marginLeft: '12px',
    },
    container: {
        paddingRight: '16px',
        paddingLeft: '16px',
    },
    circleCounter: {
        position: 'absolute',
        top: '-8px',
        left: '72px',
    },
}));
